<template>

    <div>
        <div class="flex flex-col w-1/2 px-4 py-0 pb-3">
            <div>
                <FormLabel htmlFor="name_group" className="mt-3">
                    Publisher Group Name
                </FormLabel>
                <input id="name" v-model="form.name" class="w-full rounded-md px-3 py-2.5 mb-1 text-sm" :class="[
                    'border rounded px-3 py-2 w-full',
                    invalidName || invalidNameEmpty
                        ? 'bg-red-300 text-red-700 border-red-400 placeholder-red-500'
                        : 'bg-gray-50 text-gray-700 border-gray-300'
                ]" type="text" placeholder="Enter Publisher Group Name" />

                <p v-if="invalidName" class="text-red-600 text-sm mt-1">
                    Publisher Group name already exist.
                </p>
                <p v-if="invalidNameEmpty" class="text-red-600 text-sm mt-1">
                    Must be filled.
                </p>
            </div>
            <div>
                <FormLabel htmlFor="publisher" className="mt-3">
                    Publisher
                </FormLabel>
                <multiselect v-model="form.vendors" label="name" track-by="name" placeholder="Select Publisher"
                    class="box-border custom-multiselect" :class="invalidVendorsEmpty ? 'error' : ''"
                    open-direction="bottom" :options="items_vendor" :searchable="true" :loading="isLoadingSearch"
                    :close-on-select="true" :multiple="true" @search-change="findVendorName">
                    <template slot="tag" slot-scope="{ option, remove }">
                        <span class="inline-flex items-center text-sm font-medium rounded px-2 py-1 mr-1 mb-1 border"
                            :class="vendorsAlready.includes(option.id)
                                ? 'bg-red-100 text-red-700 border-red-400'
                                : 'bg-blue-100 text-blue-700 border-blue-300'">
                            {{ option.name }}
                            <button class="ml-1 text-xs font-bold focus:outline-none"
                                @click.stop="removeAndUpdateInvalid(option, remove)">
                                ✕
                            </button>
                        </span>
                    </template>

                    <span slot="noResult" class="text-gray-500">
                        Oops! No elements found. Consider changing the search query.
                    </span>
                </multiselect>

                <p v-if="vendorsAlready.length" class="text-red-600 text-sm mt-1">
                    Publisher is already registered in another Publisher Group.
                </p>
                <p v-if="invalidVendorsEmpty" class="text-red-600 text-sm mt-1">
                    Must be filled.
                </p>

            </div>
        </div>
    </div>
</template>

<script>
import FormLabel from '@/components/ui/FormLabel';
import { mapActions, } from 'vuex';

export default {
    name: 'formDataPublisherGroup',
    props: {
        form: {
            type: Object,
            required: true
        },
        vendorsAlready: {
            type: Array,
            default: () => []
        },
        invalidName: {
            type: Boolean,
        },
        invalidNameEmpty: Boolean,
        invalidVendorsEmpty: {
            type: Boolean,
        },

    },
    components: {
        FormLabel
    },

    created() {

    },
    data() {
        return {
            isLoadingSearch: false,
            items_vendor: [],
            localInvalidName: this.invalidName,
            localEmptyName: this.invalidNameEmpty,
            localEmptyVendor: this.invalidVendorsEmpty
        };
    },

    watch: {
        'form.name'() {
            this.localInvalidName = false;
            this.localEmptyName = false
            this.$emit('update:invalidName', false);
            this.$emit('update:invalidNameEmpty', false);

        },
        'form.vendors'() {
            this.localEmptyVendor = false
            this.$emit('update:invalidVendorsEmpty', false);
        }
    },

    methods: {
        ...mapActions('vendors', ['findVendor']),
        findVendorName(keyword) {
            if (keyword.length > 2) {
                this.isLoadingSearch = true;
                let payload = {
                    q: keyword,
                };
                this.findVendor(payload)
                    .then((resp) => {
                        this.items_vendor = resp.data.data;
                        this.isLoadingSearch = false;
                    })
                    .catch((err) => {
                        this.isLoadingSearch = false;
                        console.log(err);
                    });
            }
        },
        removeAndUpdateInvalid(option, remove) {
            remove(option);
            const index = this.vendorsAlready.indexOf(option.id);
            if (index !== -1) {
                this.vendorsAlready.splice(index, 1);
            }
        }

    }
};
</script>
